import {Component, OnDestroy, OnInit} from '@angular/core';
import {MessageService} from '@app/app/shared/services/message.service';
import {AWSService} from '@app/app/shared/services/aws.service';
import * as moment from 'moment';
import {Observable} from 'rxjs/Observable';
import {HttpClient} from '@angular/common/http';
import {TimerObservable} from 'rxjs/observable/TimerObservable';
import {Subscription} from 'rxjs/Subscription';
import {UrlHelper} from '@app/app/shared/helpers/url.helper';

@Component({
  templateUrl: './sidebar.html',
  styleUrls: ['sidebar.css'],
  selector: 'sidebar'
})
export class SidebarComponent implements OnInit, OnDestroy {
  public activeAlarms = [];
  public dueTasks = [];
  public waterConsumption = 0;
  public locations = {};
  public center = {lat: 0, lon: 0};
  public objectKeys = Object.keys;
  public fullName = '';

  private alarmsSubscription: Subscription;
  private tasksSubscription: Subscription;
  private statsSubscription: Subscription;
  private locationsSubscription: Subscription;
  public logoUrl = 'assets/img/vortex_logo_blue.svg';
  public isLoadingLogo = false;

  private refreshPeriod = 10000;

  public colorRed(due_date) {
    return moment(due_date, 'MMM Do YYYY').isBefore(moment());
  }

  constructor(private sender: MessageService, private aws: AWSService, private http: HttpClient, private urlHelper: UrlHelper) {
    //
  }

  public loadImage() {
    this.isLoadingLogo = true;

    this.http.get('/users/me').subscribe((res: any) => {
      this.logoUrl = res.data.attributes.image || this.logoUrl;
      this.fullName = `${res.data.attributes.first_name} ${res.data.attributes.last_name}`;
      this.isLoadingLogo = false;
    }, () => {
      this.isLoadingLogo = false;
    });
  }

  public sortedActiveAlarms() {
    // Sorting by due date (newest first)
    // Then splash pad name(alphabetically)
    return this.activeAlarms.sort((a, b) => {
      return a.attributes.splashpad_name - b.attributes.splashpad_name || a.attributes.timestamp - b.attributes.timestamp;
    });
  }

  retrieveAlarms() {
    return this.http.get(this.prepareAlarmsUrl(1)).expand((prev: any) => {
      if (typeof prev.meta === 'undefined' || prev.meta.pagination.current_page >= prev.meta.pagination.last_page) {
        return Observable.empty();
      }

      const nextPage = prev.meta.pagination.current_page + 1;

      return this.http.get(this.prepareAlarmsUrl(nextPage));
    }).scan((acc, r) => acc.concat(r.data), []).last();
  }

  retrieveTasks() {
    return this.http.get(this.prepareTasksUrl(1)).expand((prev: any) => {
      if (typeof prev.meta === 'undefined' || prev.meta.pagination.current_page >= prev.meta.pagination.last_page) {
        return Observable.empty();
      }

      const nextPage = prev.meta.pagination.current_page + 1;

      return this.http.get(this.prepareTasksUrl(nextPage));
    }).scan((acc, r) => acc.concat(r.data), []).last();
  }

  retrieveStats() {
    return this.http.get(this.prepareStatsUrl(1)).expand((prev: any) => {
      if (typeof prev.meta === 'undefined' || prev.meta.pagination.current_page >= prev.meta.pagination.last_page) {
        return Observable.empty();
      }

      const nextPage = prev.meta.pagination.current_page + 1;

      return this.http.get(this.prepareStatsUrl(nextPage));
    }).scan((acc, r) => acc.concat(r.data), []).last();
  }

  private prepareAlarmsUrl(page) {
    return `${this.urlHelper.getPrefix()}/alarms?filter[type]=alarm&filter[status]=pending&page=${page}`;
  }

  private prepareTasksUrl(page) {
    const date = moment().format('YYYY-MM-DD');
    return `${this.urlHelper.getPrefix()}/alarms?filter[type]=task&filter[status]=planned&page=${page}&filter[due_date]=${date}&sort=due_date`;
  }

  private prepareStatsUrl(page) {
    return `${this.urlHelper.getPrefix()}/stats?page=${page}`;
  }

  private getAlarms() {
    this.retrieveAlarms().subscribe((alarms) => {
      this.activeAlarms = alarms;

      /*alarms.forEach((alarm) => {
        this.activeAlarms.push([alarm.attributes.timestamp, alarm.attributes.splashpad_name, alarm.attributes.title]);
      });*/
    });
  }

  private getTasks() {
    this.retrieveTasks().subscribe((tasks) => {
      this.dueTasks = tasks;
    });
  }

  private getStats() {
    this.retrieveStats().subscribe((stats) => {
      this.waterConsumption = 0;

      stats.forEach((stat) => {
        this.waterConsumption += parseFloat(stat.attributes.value);
      });
    });
  }

  private getLocations() {
    this.http.get(`${this.urlHelper.getPrefix()}/locations`).subscribe((res: any) => {
      let cLat = 0;
      let cLon = 0;

      res.data.forEach(location => {
        this.locations[location.id] = location.attributes;

        cLat += parseFloat(location.attributes.latitude);
        cLon += parseFloat(location.attributes.longitude);
      });

      cLat /= res.data.length;
      cLon /= res.data.length;

      this.center.lat = cLat;
      this.center.lon = cLon;
    });
  }

  ngOnInit() {
    this.loadImage();

    // Run refresh each 10 seconds

    this.alarmsSubscription = TimerObservable.create(0, this.refreshPeriod).subscribe(() => {
      this.getAlarms();
    });

    this.tasksSubscription = TimerObservable.create(0, this.refreshPeriod).subscribe(() => {
      this.getTasks();
    });

    this.statsSubscription = TimerObservable.create(0, this.refreshPeriod).subscribe(() => {
      this.getStats();
    });

    this.locationsSubscription = TimerObservable.create(0, this.refreshPeriod).subscribe(() => {
      this.getLocations();
    });
  }

  ngOnDestroy() {
    if (this.alarmsSubscription) {
      this.alarmsSubscription.unsubscribe();
    }

    if (this.tasksSubscription) {
      this.tasksSubscription.unsubscribe();
    }

    if (this.statsSubscription) {
      this.statsSubscription.unsubscribe();
    }

    if (this.locationsSubscription) {
      this.locationsSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/components/sidebar/sidebar.component.ts